// src/actions/fashionphoto_actions.js
import { fetchFashionPhotos } from "../util/fashionphoto_api_util";

export const FASHIONPHOTOS_REQUEST = "FASHIONPHOTOS_REQUEST";
export const FASHIONPHOTOS_SUCCESS = "FASHIONPHOTOS_SUCCESS";
export const FASHIONPHOTOS_FAILURE = "FASHIONPHOTOS_FAILURE";

export const requestFashionPhotos = () => ({ type: FASHIONPHOTOS_REQUEST });
export const receiveFashionPhotos = (items) => ({ type: FASHIONPHOTOS_SUCCESS, items });
export const failFashionPhotos = (error) => ({ type: FASHIONPHOTOS_FAILURE, error });

export const getFashionPhotos = () => async (dispatch) => {
  dispatch(requestFashionPhotos());
  try {
    const items = await fetchFashionPhotos();
    dispatch(receiveFashionPhotos(items));
  } catch (err) {
    dispatch(failFashionPhotos(err.message || "Failed to load photos"));
  }
};

// alias to satisfy existing imports
export { getFashionPhotos as fetchAllFashionPhotos };
